"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Check = _interopRequireDefault(require("@insided/shared/icons/Check"));

var _Close = _interopRequireDefault(require("@insided/shared/icons/Close"));

var _excluded = ["checked", "onChange", "disabled", "className"];

/**
 * ToggleSwitch Switch Component
 *
 * A modern toggle switch with rounded pill design.
 */
var ToggleSwitch = function ToggleSwitch(_ref) {
  var checked = _ref.checked,
      onChange = _ref.onChange,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      buttonProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);

  var handleClick = function handleClick(e) {
    e.preventDefault();
    e.stopPropagation();

    if (!disabled) {
      onChange(!checked);
    }
  };

  var handleKeyDown = function handleKeyDown(e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();

      if (!disabled) {
        onChange(!checked);
      }
    }
  };

  return (0, _preact.h)("button", (0, _extends2.default)({
    type: "button",
    className: (0, _classnames.default)('toggle-switch', className, {
      checked: checked
    }),
    onClick: handleClick,
    onKeyDown: handleKeyDown,
    role: "switch",
    "aria-checked": checked,
    disabled: disabled
  }, buttonProps), (0, _preact.h)("span", {
    className: "toggle-slider",
    "aria-hidden": "true"
  }, checked ? (0, _preact.h)(_Check.default, {
    className: "toggle-icon toggle-icon-check"
  }) : (0, _preact.h)(_Close.default, {
    className: "toggle-icon toggle-icon-cross"
  }), (0, _preact.h)("span", {
    className: "toggle-knob"
  })));
};

var _default = ToggleSwitch;
exports.default = _default;